<template>
  <section
    id="vision"
    class="vision"
  >
    <div class="container">
      <div class="vision-container">
        <h2>重塑硬件设计未来</h2>
        <div class="vision-content">
          <div class="vision-text">
            <p>
              电子设计将演变为"智能增强创造"的新范式，让任何人都能像编写软件一样便捷地创造硬件。
            </p>
            <p>
              从"设计-制造-测试"线性模式进化为"需求-创造-服务"的动态网络，DesignPulse将催生万亿级长尾电子市场。
            </p>
            <p>
              到2035年，任何有创意的个人/企业都能通过AI辅助平台快速实现硬件创新，设计周期与成本降至当前的1/100。
            </p>
          </div>
          <div class="vision-image">
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Future Vision"
            >
          </div>
        </div>
        <div class="vision-stats">
          <div class="vision-stat">
            <div class="vision-value">
              99%
            </div>
            <div class="vision-label">
              设计周期缩短
            </div>
          </div>
          <div class="vision-stat">
            <div class="vision-value">
              99%
            </div>
            <div class="vision-label">
              成本降低比例
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.vision {
  background: linear-gradient(to right, var(--gray-100), var(--gray-200));
  color: var(--gray-800);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.vision:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
  opacity: 0.2;
}

.vision-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.vision h2 {
  font-size: 3rem;
  margin-bottom: 50px;
}

.vision-content {
  display: flex;
  gap: 60px;
  align-items: center;
  margin-bottom: 60px;
  text-align: left;
}

.vision-text {
  flex: 1;
}

.vision-text p {
  margin-bottom: 25px;
  font-size: 1.2rem;
  opacity: 0.9;
  line-height: 1.8;
}

.vision-image {
  flex: 1;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
  animation: pulse 6s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.2);
  }
  70% {
    box-shadow: 0 0 0 25px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.vision-image img {
  width: 100%;
  display: block;
}

.vision-stats {
  display: flex;
  justify-content: center;
  gap: 80px;
  margin-top: 40px;
}

.vision-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vision-value {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 15px;
  background: linear-gradient(to right, var(--gray-500), var(--gray-700));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.vision-label {
  font-size: 1.3rem;
  opacity: 0.9;
}
</style>
